import React from "react"
import {
  AutoLoadEpisodes,
  IEpisodeFuncProps,
} from "../../components/templates/auto-load-episodes"
import { Wrapper } from "../../components/templates/wrapper"
import { JSONRPCClientBuilder } from "../../request/JSONRPCClientBuilder"
import { Episode, EpisodeRPC } from "../../rpcs/dist/EpisodeRPC"
import Width from "../../style/enum/width"
import { RouteComponentProps } from "react-router"
import { Headline } from "../../components/parts/headline/headline"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTag } from "@fortawesome/free-solid-svg-icons/faTag"
import { container, IContainerProps } from "./container"

type IProps = RouteComponentProps<{
  name: string
}> &
  IContainerProps

class TagIndex extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props)
    this.getEpisodeFunc = this.getEpisodeFunc.bind(this)
    this.update = this.update.bind(this)
    this.reset = this.reset.bind(this)
  }

  public render() {
    return (
      <Wrapper maxWidth={Width.EPISODE_LIST}>
        <Headline horizontalMargin={true}>
          <FontAwesomeIcon icon={faTag} /> タグ「
          <b>{this.props.match.params.name}</b>」
        </Headline>
        <AutoLoadEpisodes
          episodes={this.props.episode}
          update={this.update}
          reset={this.reset}
          getEpisodeFunc={this.getEpisodeFunc}
        />
      </Wrapper>
    )
  }

  private getEpisodeFunc(props: IEpisodeFuncProps) {
    const episodeRPC = JSONRPCClientBuilder.build(EpisodeRPC)
    return episodeRPC.listEpisodesByTag({
      tag: this.props.match.params.name,
      page: props.page,
    })
  }

  private update(res: Episode[]) {
    this.props.actions.updateEpisodes(res)
  }

  private reset() {
    this.props.actions.resetEpisode()
  }
}

export default container(TagIndex)
